(ns manatee.admin.pending-items.app-db
  "App. DB support for the Admin. Pending Items tab."
  (:require [manatee.admin.app-db :as admin-app-db]))

(def ^:private pending-items-path
  (conj admin-app-db/root-path :pending-items))
(def ^:private pending-items-to-reassign-path
  (conj admin-app-db/root-path :pending-items-to-assign))
(def ^:private user-to-assign-to-path
  (conj admin-app-db/root-path :user-to-assing-to))

(defn get-pending-items
  [db]
  (get-in db pending-items-path))

(defn set-pending-items
  [db items]
  (assoc-in db pending-items-path items))

(defn get-pending-items-to-reassign
  [db]
  (get-in db pending-items-to-reassign-path))

(defn get-user-to-assign-to
  [db]
  (get-in db user-to-assign-to-path))

(defn set-user-to-assign-to
  [db user]
  (assoc-in db user-to-assign-to-path user))

(defn update-pending-items-to-reassign
  "Update the collection of items to be reassigned. Note that the first element
   of `args` is the function that `update-in` will use to 'update' the value."
  [db & args]
  ; Note; the element of `args
  (apply update-in db pending-items-to-reassign-path args))
